import { HttpErrorResponse } from '@common/http/models/http-error-response.model';
import { MadCloudError } from '@common/http/models/mad-cloud-error.model';
import { MadCloudResult } from '@common/http/models/mad-cloud-result.model';
import { WrappedError } from '@common/http/models/wrapped-error.model';

export function instanceOfHttpErrorResponse(obj: unknown): obj is HttpErrorResponse {
  return typeof obj === 'object' && obj !== null && ('error' in obj || 'statusText' in obj);
}

export function instanceOfMadCloudResult<T = unknown>(obj: unknown): obj is MadCloudResult<T> {
  return typeof obj === 'object' && obj !== null && 'Succeeded' in obj;
}

export function instanceOfMadCloudError(obj: unknown): obj is MadCloudError {
  return typeof obj === 'object' && obj !== null && 'Message' in obj;
}

export function instanceOfWrappedError(obj: unknown): obj is WrappedError {
  return typeof obj === 'object' && obj !== null && 'error' in obj && obj.error instanceof Error;
}

/**
 * Narrows a caught value to one carrying a string `name` (with an optional `message`). Prefer this
 * over `instanceof Error` for classifying caught errors, because the collab doc workers throw plain
 * `{ name, message, stack }` objects across the worker_threads boundary (see `throwWorkerError`)
 * that are structurally error-like but are NOT `Error` instances.
 */
export function hasErrorName(value: unknown): value is { name: string; message?: string } {
  return typeof value === 'object' && value !== null && typeof (value as { name?: unknown }).name === 'string';
}
